'use client'
import { useState } from 'react'

const items = [
  { q: 'Wat gebeurt er na de proefperiode?', a: 'Na 30 dagen krijg je een herinnering. Je kunt dan kiezen voor een betaald abonnement of stoppen, zonder automatische incasso of verplichtingen.' },
  { q: 'Kan ik wisselen tussen plannen?', a: 'Ja, op elk moment. Upgrade gaat direct in. Downgrade gaat in bij de volgende factuurperiode.' },
  { q: 'Werkt Servd met onze huidige boekhouder?', a: 'Ja, met Moneybird en eBoekhouden. De automatische koppeling zit in het Business-plan: facturatie en betaling lopen dan via je boekhoudpakket, en automatische incasso kan alleen via Moneybird. Op Pro exporteer je facturen in bulk (CSV en PDF), op Starter per factuur.' },
  { q: 'Kunnen onze cursisten de app gewoon gebruiken?', a: 'Ja. De cursisten-app is gratis voor cursisten en hun ouders, alleen jullie als school betalen het abonnement.' },
]

export function FAQ() {
  const [open, setOpen] = useState(0)

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: 8, maxWidth: 760}}>
      {items.map((item, i) => (
        <div key={i} style={{
          background: 'var(--bg-elevated)',
          border: '1px solid var(--hairline)',
          borderRadius: 14,
          overflow: 'hidden',
        }}>
          <button
            type="button"
            onClick={() => setOpen(open === i ? -1 : i)}
            style={{
              width: '100%',
              padding: '18px 22px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              fontFamily: 'var(--display)',
              fontSize: 17,
              fontWeight: 600,
              letterSpacing: '-0.015em',
              color: 'var(--ink)',
              textAlign: 'left',
            }}
          >
            {item.q}
            <span style={{
              fontFamily: 'var(--mono)',
              fontSize: 14,
              color: 'var(--clay-text)',
              transition: 'transform 200ms',
              transform: open === i ? 'rotate(45deg)' : 'rotate(0deg)',
            }}>+</span>
          </button>
          {open === i && (
            <div style={{padding: '0 22px 20px', fontSize: 14, color: 'var(--mute)', lineHeight: 1.6, maxWidth: 620}}>{item.a}</div>
          )}
        </div>
      ))}
    </div>
  )
}
